import { PortableText as PT } from '@portabletext/react';
import PropTypes from 'prop-types';

import { postDetailSerializers, tileSerializers } from './serializers';

const PortableText = ({ blocks, renderLinks = true }) => {
  const s = renderLinks ? postDetailSerializers : tileSerializers;
  return <PT value={blocks} components={s} />;
};

export default PortableText;

PortableText.propTypes = {
  blocks: PropTypes.arrayOf(PropTypes.shape({})),
  renderLinks: PropTypes.bool,
};
